(function () {
  function initStoryCarousel() {
    var car = document.getElementById('storycar');
    var avs = document.getElementById('avs');
    if (!car || !avs) return;

    var track = car.querySelector('.car__track');
    var slides = track.children;
    var dots = car.querySelector('.car__dots');
    var count = slides.length;
    var current = 0;

    for (var index = 0; index < count; index += 1) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.setAttribute('aria-label', 'Story ' + (index + 1));
      dot.dataset.i = index;
      if (index === 0) dot.className = 'on';
      dots.appendChild(dot);
    }

    function sync() {
      Array.prototype.forEach.call(dots.children, function (dot, index) {
        dot.className = index === current ? 'on' : '';
      });
      Array.prototype.forEach.call(avs.children, function (avatar, index) {
        avatar.className = index === current ? 'on' : '';
      });
    }

    function go(index) {
      current = Math.max(0, Math.min(count - 1, index));
      track.scrollTo({
        left: slides[current].offsetLeft - track.offsetLeft,
        behavior: 'smooth'
      });
      sync();
    }

    car.querySelector('.car__arrow--prev').addEventListener('click', function () { go(current - 1); });
    car.querySelector('.car__arrow--next').addEventListener('click', function () { go(current + 1); });
    dots.addEventListener('click', function (event) {
      if (event.target.dataset.i !== undefined) go(Number(event.target.dataset.i));
    });
    avs.addEventListener('click', function (event) {
      var button = event.target.closest('button');
      if (button) go(Number(button.dataset.i));
    });

    var scrollTimer;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var best = 0;
        var minimum = Number.POSITIVE_INFINITY;
        for (var index = 0; index < count; index += 1) {
          var distance = Math.abs(slides[index].offsetLeft - track.offsetLeft - track.scrollLeft);
          if (distance < minimum) {
            minimum = distance;
            best = index;
          }
        }
        current = best;
        sync();
      }, 90);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStoryCarousel);
  } else {
    initStoryCarousel();
  }
})();
